import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarStateService {
  public sidebarToggle$ = new Subject<boolean>();
}
